import React, { useEffect } from 'react';
import { useAuth } from '../AuthProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { isValidTenantRoute, getTenantBasePath } from '../utils/tenantNavigation';
import { message } from 'antd';

const RouteGuard = ({ children }) => {
  const { tenantType, currentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Only check routes for authenticated users
    if (!currentUser || !tenantType) {
      return;
    }

    // Skip check for auth routes
    if (location.pathname.startsWith('/login') || 
        location.pathname.startsWith('/signup') || 
        location.pathname.startsWith('/forgot-password') ||
        location.pathname.startsWith('/verify-email') ||
        location.pathname.startsWith('/reset-password')) {
      return;
    }

    // Check if current route is valid for the tenant
    if (!isValidTenantRoute(tenantType, location.pathname)) {
      console.warn(`Unauthorized route access attempt: ${location.pathname} for tenant: ${tenantType}`);
            
      // Redirect to appropriate tenant dashboard
      const correctPath = getTenantBasePath(tenantType);
      navigate(correctPath, { replace: true });
    }
  }, [location.pathname, tenantType, currentUser, navigate]);

  return children;
};

export default RouteGuard; 